const React = require('react');
const T = require('prop-types');
const { NavLink: Link } = require('react-router-dom');
const Moment = require('moment');

const { default: linkifyHtml } = require('linkify-html');

const Avatar = require('components/ProfileAvatar');
const { default: MuiListItem } = require('@mui/material/ListItem');
const { default: MuiListItemText } = require('@mui/material/ListItemText');
const { default: FlatButton } = require('@mui/material/Button');
const { default: MuiGroupIcon } = require('@mui/icons-material/Group');
const { default: MuiAnnouncementIcon } = require('@mui/icons-material/Announcement');
const { default: AssignmentIcon } = require('@mui/icons-material/Assignment');
const { default: RedoIcon } = require('@mui/icons-material/Redo');
const { default: MuiNewReleasesIcon } = require('@mui/icons-material/NewReleases');
const { default: MuiLocalOfferIcon } = require('@mui/icons-material/LocalOffer');
const { default: MuiMenuBookIcon } = require('@mui/icons-material/MenuBook');
const { default: Styled } = require('styled-components');
const PlayStore = require('static/google_play.svg');
const AppStore = require('static/app_store.svg');
const { REACTIONS } = require('utils/constants');

const { getDisplayImageUrl, getSizedImageUrl } = require('utils/image');
const Emoji = require('components/Emoji');

const ItemBody = require('../Chat/ItemBody');

const { formatSimilarityText } = require('utils/makeUsersSimilarityText');
const FocusIndicator = require('components/FocusIndicator');

const StyledSurveyListItemText = Styled(MuiListItemText)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.between(theme.breakpoints.values.mobileL, theme.breakpoints.values.sm)]: {
        flexBasis: '80%'
    },
    [theme.breakpoints.between(theme.breakpoints.values.mobileM, theme.breakpoints.values.mobileL)]: {
        flexBasis: '75%'
    },
    [theme.breakpoints.down(theme.breakpoints.values.mobileM)]: {
        flexBasis: '70%'
    }
}));

const internals = {};

module.exports = class NotificationItem extends React.Component {

    static propTypes = {
        onRequestIgnore: T.func,
        onRequestAccept: T.func,
        onDismissNotification: T.func,
        onAcceptTransfer: T.func,
        showNotification: T.func,
        currentUserRolesInteractions: T.arrayOf(T.shape({
            id: T.number,
            name: T.string,
            label: T.string,
            schoolId: T.number,
            canViewProfile: T.bool
        })),
        notification: T.shape({
            id: T.any.isRequired,
            channelType: T.string,
            channelSid: T.string,
            emojiSymbol: T.string,
            info: T.shape({
                text: T.string,
                appInstall: T.bool,
                similarityText: T.string,
                surveyId: T.number,
                surveyName: T.string,
                emojiSymbol: T.string,
                responses: T.arrayOf(T.shape({
                    value: T.string,
                    label: T.string
                })),
                schoolName: T.string,
                offerId: T.number,
                resourceId: T.number,
                brandName: T.string,
                brandLogoUrl: T.string,
                title: T.string
            }),
            class: T.shape({
                id: T.string,
                name: T.string,
                emojiSymbol: T.string
            }),
            createdAt: T.string, // A date
            sender: T.shape({
                id: T.any.isRequired,
                croppedPicture: T.string,
                firstName: T.string,
                lastName: T.string,
                roleId: T.number
            }),
            groupDetails: T.shape({
                class: T.shape({
                    id: T.string,
                    name: T.string,
                    emojiSymbol: T.string
                })
            }),
            transferDetails: T.shape({
                class: T.shape({
                    id: T.string,
                    name: T.string,
                    emojiSymbol: T.string
                }),
                transfer: T.shape({
                    id: T.string,
                    name: T.string
                })
            }),
            type: T.oneOf([
                'peer',
                'transfer',
                'announcement',
                'question',
                'group-invite',
                'survey',
                'reaction',
                'offer',
                'resource',
                'welcome'
            ]).isRequired,
            status: T.oneOf(['new', 'accepted']),
            read: T.bool,
            marked: T.oneOf(['declined', 'accepted', null])
        }),
        onLeave: T.func,
        onClickJoinClass: T.func,
        onClickAnswerQuestion: T.func
    }

    onClickJoinClass = (id, name, isTransfer) => {

        const {
            onLeave,
            onClickJoinClass,
            onAcceptTransfer,
            onDismissNotification,
            notification
        } = this.props;

        return () => {

            onClickJoinClass({ id, name });
            onLeave();

            if (isTransfer) {
                onAcceptTransfer(notification);
            }

            onDismissNotification(notification);
            FocusIndicator.onBlurHandler();
        };
    }

    onClickIgnoreClass = () => {

        const {
            onLeave,
            onDismissNotification,
            notification
        } = this.props;

        return () => {

            onLeave();
            onDismissNotification(notification);
            FocusIndicator.onBlurHandler();
        };
    }

    onClickAnswerQuestion = (answer) => {

        const { onClickAnswerQuestion, notification: { id } } = this.props;

        return () => onClickAnswerQuestion({ notificationId: id, answer });
    }

    accept = () => {

        this.props.onRequestAccept(this.props.notification);
        FocusIndicator.onBlurHandler();
    }

    ignore = () => {

        this.props.onRequestIgnore(this.props.notification);
        FocusIndicator.onBlurHandler();
    }

    render() {

        const {
            onLeave,
            notification: {
                createdAt,
                sender,
                type,
                status,
                marked,
                transferDetails,
                groupDetails,
                channelType,
                channelSid,
                emojiSymbol: notificationEmoji,
                info,
                class: class_
            },
            currentUserRolesInteractions,
            showNotification,
            // eslint-disable-next-line no-unused-vars
            onDismissNotification,
            ...rest
        } = this.props;

        const {
            contentMap,
            AnnouncementIcon,
            ListItem,
            ListItemText,
            ListMainContentRow,
            ListItemAvatar,
            ActionButtonsContainer,
            ProfileRouterLink,
            ProfileLink,
            GroupIcon,
            NewReleasesIcon,
            OfferIcon,
            ResourceIcon,
            BrandLogo,
            AcceptButton,
            RouterLinkNoUnderline,
            QuestionRoot,
            ResponseButton,
            AppStoreLinks
        } = internals;

        const { text } = (contentMap[status] && contentMap[status][type]) || { text: '' };

        let canViewSenderProfile = false;

        if (sender && (type === 'peer' || type === 'mention')) {
            const { roleId: senderRoleId } = sender;

            const senderRoleInteractions = currentUserRolesInteractions?.find((roleInteractions) => {

                return roleInteractions.id === senderRoleId;
            });

            canViewSenderProfile = senderRoleInteractions?.canViewProfile ?? false;
        }

        let ClassIcon = () => {

            return <GroupIcon />;
        };

        if (groupDetails && groupDetails.class && groupDetails.class.emojiSymbol) {
            // eslint-disable-next-line react/display-name
            ClassIcon = () => {

                return <Emoji symbol={groupDetails.class.emojiSymbol} />;
            };
        }

        let CustomAnnouncementIcon = () => {

            return (
                <ListItemAvatar>
                    <AnnouncementIcon />
                </ListItemAvatar>
            );
        };

        if (notificationEmoji?.length) {
            // eslint-disable-next-line react/display-name
            CustomAnnouncementIcon = () => {

                return (
                    <ListItemAvatar>
                        <Emoji symbol={notificationEmoji} style={{ marginTop: -8 }} />
                    </ListItemAvatar>
                );
            };
        }

        const ReactionIcon = () => {

            return (
                <ListItemAvatar>
                    <Emoji symbol={REACTIONS[info.emojiSymbol]} style={{ marginTop: -8 }} />
                </ListItemAvatar>
            );
        };

        // marked is null by default
        const notificationText = marked ? text[marked] : (text.default ? text.default : text);
        const options = {
            defaultProtocol: 'https',
            format: () => 'link',
            target: '_blank',
            rel: 'noopener noreferrer'
        };

        const processedText = linkifyHtml(
            info.text || '',
            options
        );

        // Peer request
        if (type === 'peer') {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            {canViewSenderProfile ?
                                <Link
                                    aria-label={`Link to ${sender.firstName} ${sender.lastName}'s profile`}
                                    onClick={onLeave}
                                    to={`/app/profile/${sender.id}`}
                                    data-focus-outline='radius:40,padding:2'
                                    style={{ display: 'inline-block' }}
                                >
                                    <Avatar src={getSizedImageUrl(sender.croppedPicture, 100)} alt={sender.firstName + ' ' + sender.lastName} />
                                </Link> :
                                <a
                                    onClick={() => {

                                        showNotification('Sorry, you cannot see this user\'s profile');
                                        onLeave();
                                    }}
                                    style={{ display: 'inline-block' }}
                                    data-focus-outline='radius:40'
                                    tabIndex={0}
                                    role='button'
                                >
                                    <Avatar src={getSizedImageUrl(sender.croppedPicture, 100)} alt={sender.firstName + ' ' + sender.lastName} />
                                </a>
                            }
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>
                                    <b>{canViewSenderProfile
                                        ? (
                                            <ProfileRouterLink
                                                aria-label={`Link to ${sender.firstName} ${sender.lastName}'s profile`}
                                                onClick={onLeave}
                                                to={`/app/profile/${sender.id}`}
                                                data-focus-outline='radius:5,padding:2'
                                            >
                                                {`${sender.firstName} ${sender.lastName}`}
                                            </ProfileRouterLink>
                                        )
                                        : (
                                            <ProfileLink
                                                onClick={() => {

                                                    showNotification('Sorry, you cannot see this user\'s profile');
                                                    onLeave();
                                                }}
                                                data-focus-outline='radius:5,padding:2'
                                                tabIndex={0}
                                                role='button'
                                            >
                                                {`${sender.firstName} ${sender.lastName}`}
                                            </ProfileLink>
                                        )
                                    }
                                    </b> {notificationText} {(info && info.similarityText) ? <span dangerouslySetInnerHTML={{ __html: formatSimilarityText(info.similarityText) }} /> : ''}
                                </span>
                            }
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                    {!marked && status === 'new' && (
                        <ActionButtonsContainer>
                            <AcceptButton
                                color='primary'
                                size='small'
                                variant='contained'
                                onClick={this.accept}
                                data-focus-outline='radius:40,padding:-1'
                            >
                                Accept
                            </AcceptButton>
                        </ActionButtonsContainer>
                    )}
                </ListItem>
            );
        }

        // Announcement
        if (type === 'announcement') {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <CustomAnnouncementIcon />
                        </ListItemAvatar>
                        <ListItemText
                            primary={(/<\/?[a-z][\s\S]*>/i).test(info.text) ? <div dangerouslySetInnerHTML={{
                                __html: processedText
                            }} /> : <ItemBody style={{ overflowWrap: 'break-word', whiteSpace: 'pre-line' }}>{info.text}</ItemBody>}
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                </ListItem>
            );
        }

        // Question
        if (type === 'question') {
            return (
                <QuestionRoot
                    {...rest}
                >
                    <ListMainContentRow>
                        <ListItemAvatar>
                            {'?'}
                        </ListItemAvatar>
                        <ListItemText
                            primary={<ItemBody style={{ overflowWrap: 'break-word', whiteSpace: 'pre-line' }}>{info.text}</ItemBody>}
                            secondary={Moment(createdAt).fromNow()}
                        />
                        <ActionButtonsContainer>
                            {info.responses.map((response) =>

                                <ResponseButton
                                    key={response.value}
                                    color={'primary'}
                                    onClick={this.onClickAnswerQuestion(response.value)}
                                >
                                    {response.label}
                                </ResponseButton>
                            )}
                        </ActionButtonsContainer>
                    </ListMainContentRow>
                </QuestionRoot>
            );
        }

        // Survey
        if (type === 'survey') {
            return (
                <QuestionRoot
                    {...rest}
                >
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <AssignmentIcon />
                        </ListItemAvatar>
                        <StyledSurveyListItemText
                            primary={<span >A new survey, <b><ProfileRouterLink
                                aria-label='Link to survey page'
                                onClick={onLeave}
                                to={`/app/surveys/${info.surveyId}/start`}
                                data-focus-outline='radius:6,padding:2'
                            >
                                {info.surveyName}
                            </ProfileRouterLink></b>, is now available! Please tell us how you feel!</span>}
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                </QuestionRoot>
            );
        }

        // Group Invite
        if (type === 'group-invite') {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <RouterLinkNoUnderline aria-label='Link to group page' onClick={onLeave} to={`/app/classes/${groupDetails.class.id}`}>
                                <ClassIcon />
                            </RouterLinkNoUnderline>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>
                                    Meet others in <b><ProfileRouterLink aria-label='Link to group page' onClick={onLeave} to={`/app/classes/${groupDetails.class.id}`}>{groupDetails.class.name}</ProfileRouterLink></b>! {info.text}
                                </span>
                            }
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                    <ActionButtonsContainer>
                        <AcceptButton
                            component={Link}
                            color='primary'
                            size='small'
                            variant='contained'
                            aria-label='Link to join'
                            to={`/app/classes/${groupDetails.class.id}`}
                            onClick={this.onClickJoinClass(groupDetails.class.id, groupDetails.class.name, false)}
                            data-focus-outline='radius:40,padding:-1'
                        >
                            Accept
                        </AcceptButton>
                    </ActionButtonsContainer>
                </ListItem>
            );
        }

        // Transfer
        if (type === 'transfer' && transferDetails) {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <RouterLinkNoUnderline aria-label='Link to group page' onClick={onLeave} to={`/app/classes/${transferDetails.class.id}`}>
                                <RedoIcon />
                            </RouterLinkNoUnderline>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>We see you transferred from <b>{transferDetails.transfer.name}</b>!  Join similar peers in <b>
                                    <ProfileRouterLink aria-label='Link to group page' onClick={onLeave} to={`/app/classes/${transferDetails.class.id}`}>{transferDetails.class.name}</ProfileRouterLink>
                                </b>.
                                </span>
                            }
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                    <ActionButtonsContainer>
                        <AcceptButton
                            component={Link}
                            variant='contained'
                            aria-label='Link to join group'
                            to={`/app/classes/${transferDetails.class.id}`}
                            color='primary'
                            onClick={this.onClickJoinClass(transferDetails.class.id, transferDetails.class.name, true)}
                            data-focus-outline='radius:40,padding:-1'
                        >
                            Join
                        </AcceptButton>
                    </ActionButtonsContainer>
                </ListItem>
            );
        }

        if (type === 'mention') {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <RouterLinkNoUnderline
                                aria-label='Link to chat page'
                                onClick={onLeave}
                                to={(channelType === 'class') ? `/app/classes/chat/${channelSid}` : `/app/messaging/${channelSid}`}
                                data-focus-outline='radius:40,padding:-1'
                            >
                                <Avatar src={getSizedImageUrl(sender.croppedPicture, 100)} alt={sender.firstName + ' ' + sender.lastName} />
                            </RouterLinkNoUnderline>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>You were mentioned by{' '}
                                    <b>
                                        {canViewSenderProfile ?
                                            <ProfileRouterLink
                                                aria-label='Link to user profile'
                                                onClick={onLeave}
                                                to={`/app/profile/${sender.id}`}
                                                data-focus-outline='radius:10'
                                            >
                                                {`${sender.firstName} ${sender.lastName}`}
                                            </ProfileRouterLink> :
                                            <ProfileLink
                                                onClick={() => {

                                                    showNotification('Sorry, you cannot see this user\'s profile');
                                                    onLeave();
                                                }}
                                                data-focus-outline='radius:10,padding:2'
                                                tabIndex={0}
                                                role='button'
                                            >
                                                {`${sender.firstName} ${sender.lastName}`}
                                            </ProfileLink>
                                        }
                                    </b>
                                    {' '}in{' '}
                                    {(channelType !== 'private' && channelType !== 'class') && 'a chat'}
                                    {(channelType === 'private' || channelType === 'class') && (
                                        <b>
                                            <ProfileRouterLink
                                                aria-label='Link to chat page'
                                                onClick={onLeave}
                                                to={(channelType === 'class') ? `/app/classes/chat/${channelSid}` : `/app/messaging/${channelSid}`}
                                                data-focus-outline='radius:10,padding:2'
                                            >
                                                {(channelType === 'class') && (class_?.name || 'a class chat')}
                                                {(channelType === 'private') && 'a direct message'}
                                            </ProfileRouterLink>
                                        </b>
                                    )}
                                </span>}
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                </ListItem>
            );
        }

        // Reaction
        if (type === 'reaction') {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <RouterLinkNoUnderline
                                aria-label='Link to group page'
                                onClick={onLeave}
                                to={(channelType === 'class') ? `/app/classes/chat/${channelSid}` : `/app/messaging/${channelSid}`}
                                data-focus-outline='radius:40,padding:-1'
                            >
                                <ReactionIcon />
                            </RouterLinkNoUnderline>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>
                                    <b>
                                        <ProfileRouterLink
                                            aria-label={`Link to ${sender.firstName} ${sender.lastName}'s profile`}
                                            onClick={onLeave}
                                            to={`/app/profile/${sender.id}`}
                                            data-focus-outline='radius:5,padding:2'
                                        >
                                            {`${sender.firstName} ${sender.lastName}`}
                                        </ProfileRouterLink>
                                    </b> reacted to your message
                                    {' '}in{' '}
                                    {(channelType !== 'private' && channelType !== 'class') && 'a chat'}
                                    {(channelType === 'private' || channelType === 'class') && (
                                        <b>
                                            <ProfileRouterLink
                                                aria-label='Link to chat page'
                                                onClick={onLeave}
                                                to={(channelType === 'class') ? `/app/classes/chat/${channelSid}` : `/app/messaging/${channelSid}`}
                                                data-focus-outline='radius:10,padding:2'
                                            >
                                                {(channelType === 'class') && (class_ ? class_.name : 'a class chat')}
                                                {(channelType === 'private') && 'a private chat'}
                                            </ProfileRouterLink>
                                        </b>
                                    )}
                                </span>
                            }
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                </ListItem>
            );
        }

        if (type === 'school-invite') {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <RouterLinkNoUnderline
                                aria-label='Link to Manage Communities page'
                                to='/app/manage-communities'
                                data-focus-outline='radius:40,padding:-1'
                                onClick={onLeave}
                            >
                                <NewReleasesIcon />
                            </RouterLinkNoUnderline>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>
                                    <b>
                                        <ProfileRouterLink
                                            aria-label='Link to Manage Communities page'
                                            to='/app/manage-communities'
                                            data-focus-outline='radius:10,padding:2'
                                            onClick={onLeave}
                                        >
                                            {`You're Invited to ${info.schoolName}!`}
                                        </ProfileRouterLink>
                                    </b>
                                </span>
                            }
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                </ListItem>
            );
        }

        if (type === 'offer') {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <RouterLinkNoUnderline
                                aria-label='Link to offer'
                                to={info.offerId ? `/app/offers/${info.offerId}?fromList=true` : '/app/offers'}
                                data-focus-outline='radius:40,padding:-1'
                                onClick={onLeave}
                            >
                                {info.brandLogoUrl ?
                                    <BrandLogo
                                        src={getDisplayImageUrl(info.brandLogoUrl)}
                                        alt={`${info.brandName} logo`}
                                        variant='rounded'
                                    >
                                        <OfferIcon />
                                    </BrandLogo> :
                                    <OfferIcon />}
                            </RouterLinkNoUnderline>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>
                                    Special offer from <b>
                                        <ProfileRouterLink
                                            aria-label='Link to offer'
                                            to={info.offerId ? `/app/offers/${info.offerId}?fromList=true` : '/app/offers'}
                                            data-focus-outline='radius:10,padding:2'
                                            onClick={onLeave}
                                        >
                                            {info.brandName}
                                        </ProfileRouterLink>
                                    </b>: {info.title}
                                </span>
                            }
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                </ListItem>
            );
        }

        if (type === 'resource') {
            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            <RouterLinkNoUnderline
                                aria-label='Link to resource'
                                to={info.resourceId ? `/app/resources/${info.resourceId}?fromList=true` : '/app/resources'}
                                data-focus-outline='radius:40,padding:-1'
                                onClick={onLeave}
                            >
                                {info.brandLogoUrl ?
                                    <BrandLogo
                                        src={getDisplayImageUrl(info.brandLogoUrl)}
                                        alt={`${info.brandName} logo`}
                                        variant='rounded'
                                    >
                                        <ResourceIcon />
                                    </BrandLogo> :
                                    <ResourceIcon />}
                            </RouterLinkNoUnderline>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>
                                    Resource from <b>
                                        <ProfileRouterLink
                                            aria-label='Link to resource'
                                            to={info.resourceId ? `/app/resources/${info.resourceId}?fromList=true` : '/app/resources'}
                                            data-focus-outline='radius:10,padding:2'
                                            onClick={onLeave}
                                        >
                                            {info.brandName}
                                        </ProfileRouterLink>
                                    </b>: {info.title}
                                </span>
                            }
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                </ListItem>
            );
        }

        if (type === 'welcome') {
            const isTeamsApp = process.env.APP_FLAVOUR === 'teams';

            return (
                <ListItem {...rest}>
                    <ListMainContentRow>
                        <ListItemAvatar>
                            {'👋'}
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <span>
                                    {info.text}
                                    {info.appInstall && <AppStoreLinks>
                                        <a
                                            aria-label='Download on the App Store'
                                            href={isTeamsApp
                                                ? 'https://itunes.apple.com/us/app/nearpeer-for-teams/id6445984458'
                                                : 'https://itunes.apple.com/us/app/nearpeer-for-college-students/id1300243604'}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            <img src={AppStore} alt='' />
                                        </a>
                                        <a
                                            aria-label='Get it on Google Play'
                                            href={isTeamsApp
                                                ? 'https://play.google.com/store/apps/details?id=net.nearpeer.app_business'
                                                : 'https://play.google.com/store/apps/details?id=net.nearpeer.app'}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                        >
                                            <img src={PlayStore} alt='' />
                                        </a>
                                    </AppStoreLinks>}
                                </span>
                            }
                            secondary={Moment(createdAt).fromNow()}
                        />
                    </ListMainContentRow>
                </ListItem>
            );
        }

        return null;
    }
};

internals.contentMap = {
    none: {
        transfer: {
            text: { default: null }
        }
    },
    new: { // used here as 'unanswered'
        peer: {
            text: {
                default: 'would like to connect with you!',
                accepted: 'is connected with you!'
            }
        },
        mention: {
            text: { default: null }
        },
        survey: {
            text: { default: null }
        }
    },
    accepted: {
        peer: {
            text: { default: 'is connected with you!' }
        }
    }
};

const listItemStyles = `
    display: flex;
    flex-flow: column nowrap;

    padding: 0;

    // Targeting announcement generated HTML text
    > div > div div {
        > p {
            margin: 10px 0;
        }

        > p:first-of-type {
            margin-top: 0;
        }

        > p:last-of-type {
            margin-bottom: 0;
        }
    }

    // Targeting the secondary text, we use as the timestamp
    > div > div > p {
        margin-top: 10px;
    }
`;

internals.ListItem = Styled(MuiListItem)`
    ${listItemStyles}
`;

internals.AnnouncementIcon = Styled(MuiAnnouncementIcon)`
    color: ${({ theme }) => theme.palette.primary.main};
`;

internals.GroupIcon = Styled(MuiGroupIcon)`
    color: ${({ theme }) => theme.palette.primary.main};
`;

internals.NewReleasesIcon = Styled(MuiNewReleasesIcon)`
    color: ${({ theme }) => theme.palette.primary.main};
`;

internals.OfferIcon = Styled(MuiLocalOfferIcon)`
    color: ${({ theme }) => theme.palette.primary.main};
`;

internals.ResourceIcon = Styled(MuiMenuBookIcon)`
    color: ${({ theme }) => theme.palette.primary.main};
`;

internals.BrandLogo = Styled(Avatar)`
    background-color: ${({ theme }) => theme.palette.background.paper};

    img {
        object-fit: contain;
    }
`;

internals.QuestionRoot = Styled(MuiListItem)`
    flex-wrap: wrap;
    ${listItemStyles}
`;

internals.ListMainContentRow = Styled.div`
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
`;

internals.ListItemAvatar = Styled.div`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    font-size: 40px;
    position: relative;

    width: 44px;
    height: 44px;

    * {
        display: flex;
        align-items: flex-start;
        width: 44px;
        height: 44px;
    }
`;

internals.ListItemText = Styled(MuiListItemText)`
    display: flex;
    flex-flow: column nowrap;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 20px;
`;

internals.AppStoreLinks = Styled.span`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;

    a {
        display: inline-flex;
    }

    img {
        display: block;
        height: 40px;
        width: auto;
    }
`;

internals.ActionButtonsContainer = Styled.div`
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 5px;
    padding-bottom: 5px;
`;

const actionButtonStyles = `
    min-width: 0 !important;
    width: auto;
    height: 36px;
    padding: 0 20px !important;
    font-size: 13px !important;
    line-height: 36px !important;

    &.selectedIgnored {
        background-color: ${({ theme }) => theme.palette.secondary.main} !important;
        border-color: ${({ theme }) => theme.palette.secondary.main};
        color: ${({ theme }) => theme.palette.secondary.contrastText} !important;
    }

    &.selectedAccepted {
        background-color: ${({ theme }) => theme.palette.primary.main} !important;
        border-color: ${({ theme }) => theme.palette.primary.main};
        color: ${({ theme }) => theme.palette.primary.contrastText} !important;
    }
`;

internals.AcceptButton = Styled(FlatButton)`
    ${actionButtonStyles}

    &:active {
        background-color: ${({ theme }) => theme.palette.primary.main} !important;
        border-color: ${({ theme }) => theme.palette.primary.main};
        color: ${({ theme }) => theme.palette.primary.contrastText} !important;
    }
`;

const profileLinkStyles = `
    color: ${({ theme }) => theme.palette.primary.main};
    cursor: pointer;
`;

internals.ProfileRouterLink = Styled(Link)`
    ${profileLinkStyles}
`;

internals.ProfileLink = Styled.a`
    ${profileLinkStyles}
`;

internals.RouterLinkNoUnderline = Styled(Link)`
    text-decoration: none;
`;

internals.ResponseButton = Styled(FlatButton)`
    display: block;
    min-width: 0 !important;
    height: 28px;
    padding: 0 10px !important;
    border: 1px solid !important; // Color should be same as text
    margin: 0 3px !important;
    font-size: 11px !important;
    line-height: 26px !important;
`;
